import "./page-industry.scss";
import "../../js/core";
import "../../../assets/src/eos/js/video-youtube-iframe";
import Collapse from "bootstrap/js/src/collapse";
import "../../../assets/src/eos/js/scroll-to-anchor";

$(function () {
  const modalEl = $("#modalResponseSent");

  function cleanBackdrops() {
    const backdrops = $(".modal-backdrop");
    if (backdrops.length > 1) {
      backdrops.not(":first").remove();
    }
  }

  $(document).on("hidden.bs.modal", ".modal", function () {
    if ($(".modal.show").length === 0) {
      $(".modal-backdrop").remove();
      $("body").removeClass("modal-open").css("padding-right", "");
    }
  });

  $(document).on("show.bs.modal", ".modal", cleanBackdrops);

  $(document).on("click", ".js-download-btn", function (e) {
    e.preventDefault();
    const $btn = $(this);
    const fileUrl = $btn.data("file-url");
    if (!fileUrl) return;

    const onclickCode = $btn.attr("onclick") || "";
    const eventLabelMatch = onclickCode.match(/'eventLabel':'([^']+)'/);
    const eventContextMatch = onclickCode.match(/'eventContext':'([^']+)'/);
    const eventPositionMatch = onclickCode.match(/'eventPosition':'([^']+)'/);

    const eventLabel = eventLabelMatch
      ? eventLabelMatch[1]
      : $btn.text().trim();
    const eventContext = eventContextMatch
      ? eventContextMatch[1]
      : $btn.text().trim();
    const eventPosition = eventPositionMatch
      ? eventPositionMatch[1]
      : "forest_solutions";

    fetch(fileUrl)
      .then((response) => {
        if (!response.ok) throw new Error("Download failed");
        return response.blob();
      })
      .then((blob) => {
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = fileUrl.split("/").pop();
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        // === SUCCESS ===
        dataLayer.push({
          event: "EOSCOM",
          eventCategory: "EosComEvents",
          eventAction: "pdf_download_success",
          eventLabel: eventLabel,
          eventPosition: eventPosition,
          eventContext: eventContext,
          eventContent: "",
        });

        if (modalEl.length) {
          modalEl
            .find(".modal-title")
            .text(window.downloadModalTexts?.successTitle || "");
          modalEl
            .find(".message")
            .text(window.downloadModalTexts?.successMessage || "");
          modalEl.addClass("mail_sent");

          setTimeout(() => {
            cleanBackdrops();
            modalEl.modal("show");
          }, 3500);
        }
      })
      .catch(() => {
        // === ERROR ===
        dataLayer.push({
          event: "EOSCOM",
          eventCategory: "EosComEvents",
          eventAction: "pdf_download_error",
          eventLabel: eventLabel,
          eventPosition: eventPosition,
          eventContext: eventContext,
          eventContent: "",
        });

        if (modalEl.length) {
          modalEl
            .find(".modal-title")
            .text(window.downloadModalTexts?.errorTitle || "");
          modalEl
            .find(".message")
            .text(window.downloadModalTexts?.errorMessage || "");
          modalEl.removeClass("mail_sent");

          setTimeout(() => {
            cleanBackdrops();
            modalEl.modal("show");
          }, 4500);
        }
      });
  });

  import(
    /* webpackChunkName: "chunk.owl-carousel" */ "owl.carousel/src/js/owl.carousel"
  ).then(() => {
    import(
      /* webpackChunkName: "chunk.owl-carousel-navigation" */ "owl.carousel/src/js/owl.navigation"
    ).then(() => {
      const $testimonialSlider = $(".slider-testimonials");
      const testimonialsCount = $testimonialSlider.children().length;

      if (testimonialsCount >= 2) {
        $testimonialSlider.owlCarousel({
          items: 1,
          margin: 20,
          smartSpeed: 200,
          dots: true,
          nav: true,
          responsive: {
            0: { items: 1, nav: true, dots: false },
            768: { items: 2, nav: true, dots: true },
            1200: {
              items: 2,
              nav: true,
              dots: true,
              loop: testimonialsCount > 2,
            },
          },
        });

        const handleTwoCards = () => {
          if (testimonialsCount === 2 && window.innerWidth > 768) {
            if ($testimonialSlider.data("owl.carousel")) {
              $testimonialSlider
                .trigger("destroy.owl.carousel")
                .addClass("is-double");
            }
          } else if (testimonialsCount >= 2) {
            if (!$testimonialSlider.data("owl.carousel")) {
              location.reload();
            }
            $testimonialSlider.removeClass("is-double");
          }
        };

        handleTwoCards();
        $(window).on("resize", handleTwoCards);
      } else if (testimonialsCount === 1) {
        $testimonialSlider.addClass("is-single");
      }

      $(".owl-carousel").each(function () {
        const $nav = $(this).find(".owl-nav");
        const $dots = $(this).find(".owl-dots");
        if ($nav.length || $dots.length) {
          $nav.add($dots).wrapAll("<div class='owl-controls'></div>");
        }
      });

      $(".slider-mob-solutions").owlCarousel({
        responsive: {
          0: { items: 1 },
          567: { items: 0, dots: false, nav: false, margin: 0 },
        },
        slideBy: 1,
        dots: true,
        nav: true,
        loop: false,
        margin: 20,
        smartSpeed: 200,
      });

      $(window)
        .on("resize", function () {
          if ($(window).width() < 567) {
            $(".slider-mob-solutions").addClass("owl-carousel");
          } else {
            $(".slider-mob-solutions").removeClass("owl-carousel");
          }
        })
        .trigger("resize");

      $testimonialSlider.on("click", ".testimonial-body p", function (e) {
        e.stopImmediatePropagation();
        const $this = $(this);
        if ($this.hasClass("is-truncatable") || $this.hasClass("is-expanded")) {
          $this.toggleClass("is-expanded");
          if ($testimonialSlider.hasClass("owl-carousel")) {
            setTimeout(() => {
              $testimonialSlider.trigger("refresh.owl.carousel");
            }, 150);
          }
        }
      });

      function markTruncated() {
        const $items = $testimonialSlider.find(".testimonial-body p");
        if (!$items.length) return;

        $items.each(function () {
          const $el = $(this);
          if ($el.hasClass("is-expanded")) return;

          $el.removeClass("is-truncatable");

          const isOverflowing = this.scrollHeight > this.clientHeight + 2;

          if (isOverflowing) {
            $el.addClass("is-truncatable").css("cursor", "pointer");
          } else {
            $el.css("cursor", "default");
          }
        });
      }

      setTimeout(markTruncated, 600);

      let resizeTimer;
      $(window).on("resize", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(markTruncated, 250);
      });
    });
  });

  $(document).on("click", ".js-video-play-btn", function (e) {
    e.preventDefault();
    const $wrap = $(this).closest(".js-testimonial-video-box");
    if (!$wrap.data("initial-html")) $wrap.data("initial-html", $wrap.html());
    const videoUrl = $wrap.data("video-url"),
      videoTitle = $wrap.data("video-alt");
    if (videoUrl) {
      $wrap.html(
        `<iframe allowfullscreen="" allow="autoplay" src="${videoUrl}" class="video-media" title="${videoTitle}"></iframe>`,
      );
    }
  });

  $(document).on("hidden.bs.modal", ".modal-testimonial", function () {
    const $wrap = $(this).find(".js-testimonial-video-box");
    const initialHtml = $wrap.data("initial-html");
    if (initialHtml) {
      $wrap.html(initialHtml);
      $wrap.removeData("initial-html");
    }
  });
});
